import { z } from 'zod'

export const AvailabilityTypes = z.enum(['AVAILABLE', 'UNAVAILABLE'])
export type AvailabilityTypes = z.infer<typeof AvailabilityTypes>

export const AvailabilityTypesColors = z.nativeEnum({
  [AvailabilityTypes.enum.AVAILABLE]: '#2BBB6E',
  [AvailabilityTypes.enum.UNAVAILABLE]: '#D5474C'
})
